<template>
    <div class="business-info-place-of-business">
      <z-fix-top
        keep-position
        class="fixtop"
      >
        <z-nav-bar
            v-if="!isSubmit"
            class="navbar"
            left-arrow
            title="经营场所证明"
            style="background: #F8F8F8"
            @click-left="closePage"
        >
        </z-nav-bar>
        <z-nav-bar
            v-if="isSubmit"
            class="navbar"
            right-text="关闭"
            style="background: #F8F8F8"
            @click-right="closePage"
        >
        </z-nav-bar>
      </z-fix-top>
      <section class="cell" v-if="!isSubmit">
        <div class="desc">{{msg}}</div>
                <z-cell-group inset>
                    <z-field
                        v-model="userName"
                        name="姓名"
                        label="姓名"
                        placeholder="请输入账户所有人的真实姓名"
                        :rules="[{ required: true, message: '请输入账户所有人的真实姓名' }]"
                    />
                    <z-field
                        v-model="userIdCard"
                        name="证件号码"
                        label="证件号码"
                        :maxlength="18"
                        placeholder="请输入账号所有人的身份证号"
                        :rules="[{ required: true, message: '请输入账号所有人的身份证号' }]"
                    />
                    <z-field
                        v-model="userMail"
                        name="邮箱"
                        label="邮箱"
                        placeholder="请输入接收邮箱"
                        :rules="[{ required: true, message: '请输入接收邮箱' }]"
                    />
                    <z-field
                        v-model="userPhone"
                        name="联系手机"
                        label="联系手机"
                        :maxlength="11"
                        placeholder="请输入手机号"
                        :rules="[{ required: true, message: '请输入手机号' }]"
                    />
                </z-cell-group>
                <div style="padding: 32px 0 0;">
                    <z-button size="large" :disabled="!canSubmit" type="primary" @click="submit" btn-class="confirmButton">
                        信息确认无误，提交
                    </z-button>
                </div>
     </section>
     <section class="cell"  v-if="isSubmit">
        <img :src="successImg" alt="">
        <div class="title">您已成功提交</div>
        <div class="successDesc">{{successMsg}}</div>
     </section>
    </div>
</template>
<script>
import native from '@zz-common/native-adapter';
import { FixTop, NavBar, CellGroup, Field } from '@zz-common/zz-ui'
import { submitBusinessPlace } from '@api/resourceApi';
import { queryParams } from '@lib/utils'

const query = queryParams();

export default {
  name: 'StateComp',
  data() {
    return {
      from: query.from || this.$route.query.from,
      msg: '如您需要平台为您开具经营场所证明，用于您办理营业执照，请填写并确认如下信息后提交，平台将于15个工作日内尽快通过短信或邮箱的方式向您发送【网络经营场所证明】，请您注意及时查收。',
      successMsg: '请等待平台审核办理，并办理查收',
      successImg: require('../images/place_success.png'),
      isSubmit: false,
      userName: '',
      userIdCard: '',
      userMail: '',
      userPhone: ''
    };
  },
  computed: {
    canSubmit() {
      return this.userName && this.userIdCard && this.userMail && this.userPhone
    }
  },
  methods: {
    isIDCardValid() {
      const regIdNo = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      return regIdNo.test(this.userIdCard)
    },
    isPhoneValid() {
      const regPhone = /^1[3456789]\d{9}$/
      return regPhone.test(this.userPhone)
    },
    isMailValid() {
      const regMail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      return regMail.test(this.userMail)
    },
    closePage() {
      native.close();
    },
    submit() {
      if (!this.isIDCardValid()) {
        this.$toast('身份证号错误，请填写 18 位数字和字母')
        return
      }
      if (!this.isPhoneValid()) {
        this.$toast('手机号格式错误')
        return
      }
      if (!this.isMailValid()) {
        this.$toast('邮箱格式错误')
        return
      }
      submitBusinessPlace({
        userName: this.userName,
        userIdCard: this.userIdCard,
        userMail: this.userMail,
        userPhone: this.userPhone,
        sourceCode: this.from
      }
      ).then(() => {
        this.isSubmit = true
      }).catch(err => {
        console.error(err);
      });
    }
  },
  created() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-field': Field,
    'z-cell-group': CellGroup
  }
};
</script>

<style lang='less' scoped>
@import "index.less";
</style>
